export default {
  root: {
    padding: '5rem'
  },
  outlined: {
    padding: '2rem'
  }
}
